/** ----------------------------------------
    Imports
---------------------------------------- */

import { AppStore } from '@interface/store/App';

/** ----------------------------------------
    Mutations
---------------------------------------- */

const mutations = { 

};

/** ----------------------------------------
    Export Mutations
---------------------------------------- */

export default mutations;